import React from 'react';
import { IconButton as MuiIconButton, withStyles } from '@material-ui/core';

const styles = {
  root: {
    padding: 0,
  },
};

const IconButton = props => <MuiIconButton {...props} />;

export default withStyles(styles)(IconButton);
